export default "__VITE_ASSET__bea967e1__"